import axios from 'axios';

/*
*  This file contains all axios calls related to email link clicked goal in CB
*/

export const linkMap = async (marketingEmailIds) => {
    const { data } = await axios.get(`/app/linkFunnel/linkMap/${marketingEmailIds}`);

    return data;
};
